import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FavoriteIcon from '@mui/icons-material/Favorite';

interface FeedbackToastProps {
  message: string;
  isVisible: boolean;
}

const FeedbackToast: React.FC<FeedbackToastProps> = ({ message, isVisible }) => {
  const getIcon = () => {
    if (message.includes('already liked')) {
      return <FavoriteIcon sx={{ fontSize: 16, color: '#ff4081' }} />;
    }
    return <CheckCircleIcon sx={{ fontSize: 16, color: '#4CAF50' }} />;
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: -20 }}
          transition={{
            duration: 0.3,
            ease: [0.4, 0, 0.2, 1]
          }}
                     style={{
             position: 'fixed',
             top: '20px',
             left: '50%',
             transform: 'translateX(-50%)',
             zIndex: 9999,
           }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 2,
              py: 1.5,
              borderRadius: 2,
              background: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
              minWidth: '200px',
              maxWidth: '300px',
            }}
          >
            {getIcon()}
            <Typography
              variant="body2"
              sx={{
                color: 'white',
                fontSize: '0.875rem',
                fontWeight: 500,
                textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
              }}
            >
              {message}
            </Typography>
          </Box>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FeedbackToast;
